import 'css-chunk:src/components/pages/SearchPage/TextSearchFilters/AudienceAgeSection.scss';export default {
  "AudienceAgeSection": "_AudienceAgeSection_d75ab_1",
  "multiSelectContainer": "_multiSelectContainer_d75ab_1",
  "multiSelectSelect": "_multiSelectSelect_d75ab_6",
  "multiSelectSeparator": "_multiSelectSeparator_d75ab_9"
};